import type { ChangeEvent, JSX } from "react";
import { Field, Input } from "@fluentui/react-components";
import type { InputProps } from "@fluentui/react-components";

export interface FluentInputProps {
  id?: string;
  label?: string;
  type?: InputProps["type"];
  value: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  contentBefore?: JSX.Element;
  contentAfter?: JSX.Element;
  autoComplete?: string;
  onChange: (value: string) => void;
}

export function FluentInput({
  id,
  label,
  type = "text",
  value,
  placeholder,
  disabled = false,
  required = false,
  contentBefore,
  contentAfter,
  autoComplete,
  onChange,
}: FluentInputProps): JSX.Element {
  return (
    <Field label={label} required={required}>
      <Input
        id={id}
        type={type}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        contentBefore={contentBefore}
        contentAfter={contentAfter}
        autoComplete={autoComplete}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      />
    </Field>
  );
}
